export default "__VITE_ASSET__WbWyVRFXYDxxyk7P4_8SHQ__"